import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PlatformPagesListQuery } from "../graphql/queries";
import type { PlatformPagesListQueryType } from "@/types/graphql/partner.generated";

export const usePlatformPagesQuery = (
  options?: QueryHookOptions<PlatformPagesListQueryType>
) => {
  return useQuery<PlatformPagesListQueryType>(PlatformPagesListQuery, options);
};
